import type { CoreCustomer, CoreCustomerPayload } from '@flecto/types'

import { api } from '../../../services/api'

/**
 * Create a customer for user logged.
 *
 * @endpoint POST /api/saas/me/customers
 * @scope saas
 * @see https://flecto.dev/api-4724207
 */
export async function createCustomer(
  customer: CoreCustomerPayload
): Promise<CoreCustomer> {
  const body: CoreCustomerPayload = customer

  const response = await api.post('/api/saas/me/customers', body)

  return response.data?.customer
}
